import queryString from 'query-string';

type Breakpoint = 'sm' | 'md' | 'xl';

export const getParsedUrlParams = (
  params: string,
  listingFilterParam: string
) => {
  const parsedParams = queryString.parse(params, {
    arrayFormat: 'comma',
  });

  return Object.entries(parsedParams).reduce(
    (acc: Record<string, any>, [key, value]) => {
      if (key === listingFilterParam) {
        if (Array.isArray(value)) {
          acc[key] = value;
        } else {
          acc[key] = value ? [value] : [];
        }
      } else {
        acc[key] = value;
      }
      return acc;
    },
    {}
  );
};

export const mapBreakpoint = (breakpoint: Breakpoint): Breakpoint => {
  const mapping: Record<string, Breakpoint> = {
    sm: 'sm',
    md: 'md',
    lg: 'md', // 'lg' mapped to 'md'
    xl: 'xl',
    xxl: 'xl', // 'xxl' mapped to 'xl'
  };
  return mapping[breakpoint] || breakpoint;
};
